module.exports = __webpack_public_path__ + "assets/5-tech-sales-recruiters.73402f3a.png";